export function rotate<T>(matrix: T[][]) {
  const height = matrix.length;
  if (height > 0) {
    const width = matrix[0].length;
    const newMatrix: T[][] = [];
    let newRow;
    for (let i=0; i<width; i+=1) {
      newRow = [];
      for (let j=0; j<height; j+=1) {
        newRow.push(matrix[j][i]);
      }
      newMatrix.push(newRow.reverse());
    }
    return newMatrix;
  } else {
    return [];
  }
};

export function flip<T>(matrix: T[][]) {
  return matrix.reverse();
}
